import { api } from "./api";

export interface CurrentUser {
  user_id: string;
  login: string;
  name: string;
  photo_url: string | null;
  role_name: string;
  permissions: Record<string, boolean>;
}

export async function login(login: string, password: string) {
  return api.post<{ user_id: string; name: string; permissions: Record<string, boolean> }>(
    "/auth/login",
    { login, password }
  );
}

export async function logout() {
  return api.post<{ status: string }>("/auth/logout", {});
}

export async function me(): Promise<CurrentUser> {
  return api.get<CurrentUser>("/auth/me");
}
